import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function deliveryDevicesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selectedDevices = control.get('selectedDevices')?.value;
    const createDevicesList = control.get('createDevicesList')?.value;
    
    // If neither selectedDevices nor createDevicesList is provided, return an error
    if ((selectedDevices === null || selectedDevices.length === 0) && (createDevicesList === null || createDevicesList.length === 0)) {
      return { requiredDevices: true };
    }
    return null; // No error
  };
}